import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber, injectIntl, intlShape } from 'react-intl';
import Table from './Table';
import { connect } from 'react-redux';

const ReviewSpaceRentalTable = ({
  discounts = [],
  subtotal,
  total,
  cleaningFee,
  currency = 'USD',
  baseSubtotal,
  tax,
  taxPercent,
  tip,
  tipPercent,
  isFnb,
  intl,
  masterContract,
  profile
}) => {
  const tableHeaders = [
    { label: intl.formatMessage({ id: 'inbox.review_space_rental_table.space_rental', defaultMessage: 'Space Rental' }) }
  ];

  const masterCalculations = masterContract?.calculations;
  const guestCalculations = masterCalculations?.guest;

  const isHost = masterContract?.host_sso_id === profile?.SSOid;

  return (
    <div className="review-space-rental-table margin-lg-bottom">
      <Table
        tableHeaders={tableHeaders}
        tableBody={
          (
            <div className="add-ons-rows">
              <div className="flex space-between table-row">
                <div className="title-field">
                  <FormattedMessage
                    id='inbox.review_space_rental_table.subtotal'
                    defaultMessage='Subtotal'
                  />
                </div>
                <div data-testing-id="space-rental-subtotal">
                  <FormattedNumber value={isFnb ? baseSubtotal : subtotal} currency={currency} style={'currency'} />
                </div>
              </div>

              { isFnb &&
                <div>
                  <hr className="dotted margin-md-top margin-md-bottom" />
                  <div className="flex space-between table-row" data-testing-id="tax-row">
                    <div className="title-field">
                      <FormattedMessage
                        id='inbox.review_space_rental_table.tax'
                        defaultMessage='Tax {tax}'
                        values={{
                          tax: <FormattedNumber value={taxPercent / 100} style='percent' />
                        }}
                      />
                    </div>
                    <div data-testing-id="tax-value">
                      <FormattedNumber value={tax} currency={currency} style={'currency'} />
                    </div>
                  </div>
                  <div className="flex space-between table-row" data-testing-id="tip-row">
                    <div className="title-field">
                      <FormattedMessage
                        id='inbox.review_space_rental_table.tip'
                        defaultMessage='Tip {tax}'
                        values={{
                          tax: <FormattedNumber value={tipPercent / 100} style='percent' />
                        }}
                      />
                    </div>
                    <div data-testing-id="tip-value">
                      <FormattedNumber value={tip} currency={currency} style={'currency'} />
                    </div>
                  </div>
                </div>
              }

              {
                0 < cleaningFee &&
                  <div>
                    <hr className="dotted margin-md-top margin-md-bottom" />
                    <div className="flex space-between table-row" data-testing-id="cleaning-fee-row">
                      <div className="title-field">
                        <FormattedMessage
                          id='inbox.review_space_rental_table.cleaning'
                          defaultMessage='Cleaning'
                        />
                      </div>
                      <div data-testing-id="cleaning-fee">
                        <FormattedNumber value={cleaningFee} currency={currency} style={'currency'} />
                      </div>
                    </div>
                  </div>
              }

              {!isHost && guestCalculations?.us_sales_tax_space_rental > 0 && (
                <div>
                  <hr className="dotted margin-md-top margin-md-bottom" />
                  <div
                    className="flex space-between table-row" data-testing-id="cleaning-fee-row"
                  >
                    <div className="title-field">
                      <FormattedMessage
                        id='price_table.space_rental_sales_tax'
                        defaultMessage='Space rental sales tax'
                      />
                    </div>
                    <div data-testing-id="review-table-subtotal-sales-tax">
                      <FormattedNumber
                        value={guestCalculations?.us_sales_tax_space_rental}
                        currency={currency}
                        style='currency'
                      />
                    </div>
                  </div>
                </div>
              )}

              {
                discounts.map((discount) => {
                  // only display day rate discounts here
                  if ('DAY_RATE_DISCOUNT' === discount.type) {
                    return (
                      <div>
                        <hr className="dotted margin-md-top margin-md-bottom" />
                        <div className="flex space-between discount-row table-row" data-testing-id="day-rate-discount-row">
                          <div className="title-field">
                            <FormattedMessage
                              defaultMessage='8+ hour discount ({percent})' id='inbox.review_space_rental_table.day_rate_discount'
                              values={{ percent: <FormattedNumber style='percent' value={discount.value / 100} /> }}
                            />
                          </div>
                          <div data-testing-id="day-rate-discount">
                            <FormattedNumber value={-discount.discount_amount} currency={currency} style={'currency'} />
                          </div>
                        </div>
                      </div>
                    );
                  }
                })
              }

              <hr className="dotted margin-md-top margin-md-bottom" />
              <div className="flex space-between heavier table-row">
                <div className="title-field">
                  <FormattedMessage
                    id='inbox.review_space_rental_table.space_rental_total'
                    defaultMessage='Space rental total'
                  />
                </div>
                <div data-testing-id='space-rental-total'>
                  {isHost || masterCalculations?.space_rental_guest_with_tax === undefined ? (
                    <FormattedNumber
                      value={total}
                      currency={currency}
                      style={'currency'}
                    />
                  ) : (
                    <FormattedNumber
                      value={masterCalculations?.space_rental_guest_with_tax || 0}
                      currency={currency}
                      style={'currency'}
                    />
                  )}
                </div>
              </div>
            </div>
          )
        }
      />
    </div>
  );
};

ReviewSpaceRentalTable.propTypes = {
  subtotal: PropTypes.number,
  total: PropTypes.number,
  cleaningFee: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  currency: PropTypes.string,
  discounts: PropTypes.array,
  baseSubtotal: PropTypes.number,
  tax: PropTypes.number,
  taxPercent: PropTypes.number,
  tip: PropTypes.number,
  tipPercent: PropTypes.number,
  isFnb: PropTypes.bool,
  intl: intlShape,
  masterContract: PropTypes.object,
};

const mapStateToProps = ({ profile }) => ({
  profile
});
export default injectIntl(connect(mapStateToProps)(ReviewSpaceRentalTable));
